<span class="cm-label" [title]="$label()">{{ $label() }}</span>
